<script setup lang="ts">
import './assets/style.scss'
import { useInventObjectTypesGroupModal } from './../modal/modal.ts'
import type { PropType } from 'vue'
import type { ObjectTypeGroup } from '@/entities/Inventory/ObjectSubTypes'

const props = defineProps({
  group: {
    type: Object as PropType<ObjectTypeGroup>,
  },
})

const model = useInventObjectTypesGroupModal()

/**
 * Функция обработки клика
 */
const clickHandler = () => {
  if (props.group) {
    model.data = props.group
  }

  model.open = true
}
</script>

<template>
  <div @click.prevent="clickHandler">
    <slot />
  </div>
</template>
